module.exports = __webpack_public_path__ + "static/img/xg1.450d9d12.png";